// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"bb06660a","703":"874dbaf4","820":"74828c1d"}[chunkId] + ".chunk.js";
};